import { Component, Input, EventEmitter, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { AngularCombo, AngularComboItem } from '../../models';


@Component({
    moduleId: module.id,
    selector: 'angular-combo',
    templateUrl: 'angular-combo.html'
})
export class AngularComboComponent implements OnChanges {

    @Input() comboData: AngularCombo = new AngularCombo();
    @Input() valueCombo: any;
    @Input() disabled: boolean;
    @Output() valueComboChange = new EventEmitter();
    @ViewChild('comboComponent') comboComponent: HTMLSelectElement;   

    //innerText: string;
    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["comboData"]) {
            if (this.comboData && this.comboData.ListaValori && this.comboData.ListaValori.length > 0) {    
                /*            
                let choosenElement: AngularComboItem = this.comboData.ListaValori.find(x => x.selected);
                if (choosenElement) choosenElement = this.comboData.ListaValori[0];
                this.setElement(choosenElement);
                */
            
            }
        }
    }

    onChange(event) {
        if (!event.target) 
            return;
        this.valueCombo = event.target.value;
        
        if (!this.comboData || !this.comboData.ListaValori && this.comboData.ListaValori.length > 0) return;
        this.setValueCombo(event.target.value);
                
       this.valueComboChange.emit(event.target.value);
       
    }
    /*
        private setElement(choosenElement: AngularComboItem) {
            if (choosenElement) {
                this.setValueCombo(choosenElement.value);
                this.innerText = choosenElement.descrizione;
                this.comboData.ListaValori.forEach(a => a.selected = (a.value == choosenElement.value));
            }
        }
    */
   public refresh()
   {
        this.valueComboChange.emit(this.valueCombo);
   }
    public clear() {
        if (!this.comboData || !this.comboData.ListaValori || this.comboData.ListaValori.length == 0) return;
        this.comboData.ListaValori.forEach(element => {
            element.selected = false;
        });
        //this.valueComboChange.emit(event);
    }
    public setValueCombo(value) {
        //this.valueCombo = value;        
        if (!this.comboData || !this.comboData.ListaValori || this.comboData.ListaValori.length == 0) return;
        this.clear();
        this.comboData.ListaValori.find(x => x.value == value).selected = true;
    }

    public setTextCombo(descrizione) {
        if (!this.comboData || !this.comboData.ListaValori || this.comboData.ListaValori.length == 0) return;
        this.clear();
        //this.setElement(this.comboData.ListaValori.find(x => x.descrizione == value));
        let valueObj :AngularComboItem =  this.comboData.ListaValori.find(x => x.descrizione == descrizione);
        valueObj.selected;
        this.valueCombo = valueObj.value;
    }

    public getSelectedItem(): AngularComboItem {
        let choosenElement: AngularComboItem = null;
        if (this.comboData && this.comboData.ListaValori && this.comboData.ListaValori.length > 0) {
            choosenElement = this.comboData.ListaValori.find(x => x.value == this.innerValue());
        }
        return choosenElement;
    }
    innerValue(): string {
        /*
        if (!this.comboData || !this.comboData.ListaValori || this.comboData.ListaValori.length == 0) return "";
        for (let i = 0; i < this.comboData.ListaValori.length; i++) 
        {
            if (this.comboData.ListaValori[i].selected) {
                return  this.comboData.ListaValori[i].value;
            }
    
        }
        return this.comboData.ListaValori[0].value;
        */
       return this.valueCombo;
    }
    innerText(): string {
        if (!this.comboData || !this.comboData.ListaValori || this.comboData.ListaValori.length == 0) return "";
        for (let i = 0; i < this.comboData.ListaValori.length; i++) 
        {
            if (this.comboData.ListaValori[i].selected || this.comboData.ListaValori[i].value == this.valueCombo ) {
                return  this.comboData.ListaValori[i].descrizione;
            }    
        }
        return this.comboData.ListaValori[0].descrizione;
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/combo/angular-combo.component.ts